// extracted by mini-css-extract-plugin
export default {"profileBox":"profile_profileBox__Lra-V","profileContainer":"profile_profileContainer__Y+6Vz","scrollContainerStyles":"profile_scrollContainerStyles__u6k9I"};